import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 400" rtl={true}>
      <circle cx="36" cy="26" r="26"/>
      <rect x="68" y="16" rx="5" ry="5" width="100" height="12"/>
      <rect x="68" y="32" rx="5" ry="5" width="100" height="8"/>

      <circle cx="36" cy="86" r="26"/>
      <rect x="68" y="74" rx="5" ry="5" width="100" height="12"/>
      <rect x="68" y="90" rx="5" ry="5" width="100" height="8"/>

      <circle cx="36" cy="146" r="26"/>
      <rect x="68" y="132" rx="5" ry="5" width="100" height="12"/>
      <rect x="68" y="148" rx="5" ry="5" width="100" height="8"/>

      <circle cx="36" cy="206" r="26"/>
      <rect x="68" y="190" rx="5" ry="5" width="100" height="12"/>
      <rect x="68" y="206" rx="5" ry="5" width="100" height="8"/>

      <circle cx="36" cy="266" r="26"/>
      <rect x="68" y="255" rx="5" ry="5" width="100" height="12"/>
      <rect x="68" y="272" rx="5" ry="5" width="100" height="8"/>
    </ContentLoader>
  )

}
